import React from "react";
import close_modal_dark from "../../../assets/images/close_btn.svg";
import fileIcon from "../../../assets/images/fileIcon.svg";
import { ProgressBar } from "../../../components/ui";

const formatBytes = (bytes) => {
  if (bytes == null || isNaN(bytes)) return "";
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};

const isImage = (file) =>
  file?.type?.startsWith("image/") ||
  /\.(jpe?g|png|gif|webp|bmp|svg)$/i.test(file?.name || "");

const isAudio = (file) =>
  file?.type?.includes("audio") || /\.(mp3|wav|ogg|m4a)$/i.test(file?.name || "");

const isVideo = (file) =>
  file?.type?.startsWith("video/") ||
  /\.(mp4|webm|mov|m4v|avi|mkv|ogv)$/i.test(file?.name || "");

const UploadTray = ({ uploadedFiles, setUploadedFiles }) => {
  return (
    <div className="comm-uploadtray">
      {uploadedFiles.map((file, index) => {
        if (!file) return null;

        const image = isImage(file);
        const audio = isAudio(file);
        const video = isVideo(file);
        const thumbClass = audio
          ? "comm-uploadtray__thumb comm-uploadtray__thumb--audio"
          : video
            ? "comm-uploadtray__thumb comm-uploadtray__thumb--video"
            : image
              ? "comm-uploadtray__thumb"
              : "comm-uploadtray__thumb comm-uploadtray__thumb--icon";

        return (
          <div className="comm-uploadtray__card" key={"uploadedImage" + index}>
            <div className={thumbClass}>
              {audio ? (
                <audio
                  src={URL.createObjectURL(file)}
                  controls
                  className="comm-uploadtray__audio"
                />
              ) : video ? (
                <>
                  <video
                    src={URL.createObjectURL(file)}
                    className="comm-uploadtray__video"
                    preload="metadata"
                    muted
                    playsInline
                  />
                  <span className="comm-uploadtray__play-overlay" aria-hidden="true">
                    <span className="comm-uploadtray__play-icon" />
                  </span>
                </>
              ) : image ? (
                <img src={URL.createObjectURL(file)} alt={file?.name || ""} />
              ) : (
                <img src={fileIcon} alt="" />
              )}
            </div>

            <div className="comm-uploadtray__meta">
              <span className="comm-uploadtray__name" title={file?.name || ""}>
                {file?.name || "Untitled"}
              </span>
              <span className="comm-uploadtray__size">
                {formatBytes(file?.size)}
              </span>
            </div>

            {typeof file?.progress === "number" && file.progress < 100 && (
              <ProgressBar
                className="comm-uploadtray__progress"
                value={file.progress}
                max={100}
              />
            )}

            <button
              type="button"
              className="comm-uploadtray__remove"
              aria-label={`Remove ${file?.name || "file"}`}
              onClick={() => {
                setUploadedFiles(
                  uploadedFiles.filter((_, fileIndex) => fileIndex != index)
                );
              }}
            >
              <img src={close_modal_dark} alt="" aria-hidden="true" />
            </button>
          </div>
        );
      })}
    </div>
  );
};

export default UploadTray;
